import { render, staticRenderFns } from "./third_source_search.vue?vue&type=template&id=0809d1a5&scoped=true&"
import script from "./third_source_search.vue?vue&type=script&lang=js&"
export * from "./third_source_search.vue?vue&type=script&lang=js&"
import style0 from "./third_source_search.vue?vue&type=style&index=0&id=0809d1a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0809d1a5",
  null
  
)

export default component.exports